/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/no-array-index-key */
import styled from "@emotion/styled";
import ColumnCard from "components/ColumnCard";
import BaseContainer from "components/Containers/BaseContainer";
import Text from "components/Text";
import { BlockType } from "store";
import formatImage from "../../../utils/formatImage";

type Props = {
  block: BlockType
}

const Founders = ({ block }:Props) => {
  const TextBlock = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 12px;
    width: 45%;
    @media (max-width: 1024px) {
      width: 100%;
    }
  `;
  const FoundersBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    & > div {
      width: 23%;
    }
    @media (max-width: 768px) {
      gap: 20px;
      & > div {
        width: 45%;
      }
    }
  `;
  return (
    <BaseContainer direction="column">
      <TextBlock>
        <Text tag="h2" variant="h2">
          {block.title}
        </Text>
        <Text tag="span" variant="normalBig">
          {block.text}
        </Text>
      </TextBlock>
      <FoundersBlock>
        {block.likeFoundersBlocks?.map(({ title, text, photo }, index) => (
          <ColumnCard
            key={index}
            image={formatImage(photo.link, 1280, 720, "c_fill")}
            imageHeight="300px"
            title={title}
            text={text}
            textAlign="left"
          />
        ))}
      </FoundersBlock>
    </BaseContainer>
  );
};

export default Founders;
